import { Badge, Popover, Tag } from "antd";
const tagStyleByIndex: any = (index: number) => ({
  border: `1px solid ${index === 0 ? "#7692FF" : "#AF87FF"} `,
  color: `${index === 0 ? "#7692FF" : "#AF87FF"}`,
  backgroundColor: `${index === 0 ? "#2F60FF1A" : "#AF87FF1A"}`,
  textTransform: "capitalize",
});
export const I18NColumn = ({ listRow, label, i18nFunction, t }: any) =>
  listRow?.length > 3 ? (
    <Popover
      overlayClassName="popover-country-genre"
      content={
        <div style={{ width: 500, textAlign: "center" }}>
          <span style={{ display: "block" }}>{label}</span>
          {listRow.slice(1).map((country: any, index: number) => (
            <Tag
              style={{ marginBottom: 8, ...tagStyleByIndex(index) }}
              key={Math.random()}
            >
              {i18nFunction(country)}
            </Tag>
          ))}
        </div>
      }
    >
      <Badge count={listRow.slice(1).length} status="default" color="#333333">
        <Tag key={Math.random()}>{t("pages.LabelsRanking.many")}</Tag>
      </Badge>
    </Popover>
  ) : (
    listRow.map((country: any, index: number) => (
      <Tag
        style={{ marginBottom: 8, ...tagStyleByIndex(index) }}
        key={Math.random()}
      >
        {i18nFunction(country)}
      </Tag>
    )) || ""
  );
